<template>
</template>

<script>

import moment from "moment";
import {sleep} from "@/util/sleep";
import {randomItem} from "@/util/randomItem";

export default {
  name: 'GenerativeAudio',
  props: ['src'],
  data() {
    return {
      audio: false,
      mutedState: false,
      scaleFactor: 5,
      noteOverlap: 5,
      noteTimeout: 300,
      currentNotes: 0,
      soundTotals: 51,
      maxLife: 60000,
      editTimes: [],
      audioCtx: null,
      audioBaseUrl: '/sounds/generative/',
      epm: 0,
      audioObject: new Audio('http://0.0.0.0:8080/sounds/generative/clav/c022.mp3'),
      samples: {
        clav: [],
        celesta: [],
        swells: []
      },
      audioObjects: {
        clav: [],
        celesta: [],
        swells: [],
      }
    }
  },

  computed: {

    muted: {
      async set(shouldBeMuted) {

      },

      get() {
        return this.lastAudioVolume === 0;
      }
    }

  },

  methods: {

    /**
     * Plays generative sound
     * @param size recommended to be from 1 to 1000
     * @param type 0 - most popular, 1 - second after the most popular, 3 - not popular
     * @param volume
     * @returns {Promise<void>}
     */
    async play(size, type, volume) {
      if (this.mutedState) return ;

      const maxPitch = 100.0;
      const logUsed = 1.0715307808111486871978099;
      const pitch = 100 - Math.min(maxPitch, Math.log(size + logUsed) / Math.log(logUsed));

      let index = Math.floor(pitch / 100.0 * this.samples.celesta.length);

      const fuzz = Math.floor(Math.random() * 8) - 2;

      index += fuzz;
      index = Math.min(this.samples.celesta.length - 1, index);
      index = Math.max(1, index);

      console.log(`Playing sample`, {type, index, size});

      console.log(`audioctx`, typeof this.audioCtx);

      let audio;
      if (this.currentNotes < this.noteOverlap) {
        this.currentNotes++;
        if (type === 0) {
          audio = new Audio(this.samples.celesta[index]);
          audio.volume = 0.5;
        } else if (type === 1) {
          audio = new Audio(this.samples.clav[index]);
          audio.volume = 0.5;
        } else {
          audio = new Audio((randomItem(this.samples.swells)));
        }

        await audio.play();

        setTimeout(() => {
          this.currentNotes--;
        }, this.noteTimeout);
      }
    },

    async unmute() {
      this.$emit('unmuted');
      this.mutedState = false;
      console.log(`Unmute`)
    },

    async mute() {
      this.$emit('muted');
      this.mutedState = true;
      console.log(`Mute`)

    },

    onPause: function () {
      this.paused = true;
      this.$emit('pause');

    },

    onPlay: function () {
      this.paused = false;
      this.$emit('play');
    },

    onTimeUpdate: function () {
      this.lastAudioVolume = this.audio.volume;
    },

    async loadClavSounds() {
      for (let i = 1; i < 28; i++) {
        let src = this.audioBaseUrl + `clav/c${i.toString().padStart(3, '0')}.mp3`;
        fetch(src)
          .then(response => response.blob())
          .then(blob => {
            this.samples.clav[i] = URL.createObjectURL(blob);
            new Audio(this.samples.clav[i]);
          });
      }

    },

    async loadCelestaSounds() {
      for (let i = 1; i < 28; i++) {
        let src = this.audioBaseUrl + `celesta/c${i.toString().padStart(3, '0')}.mp3`;
        fetch(src)
          .then(response => response.blob())
          .then(blob => {
            this.samples.celesta[i] = URL.createObjectURL(blob);
            new Audio(this.samples.celesta[i]);
          });
      }

    },

    async loadSwellsSounds() {
      for (let i = 1; i < 4; i++) {
        let src = this.audioBaseUrl + `swells/swell${i}.mp3`;
        fetch(src)
          .then(response => response.blob())
          .then(blob => {
            this.samples.swells[i] = URL.createObjectURL(blob);
            new Audio(this.samples.swells[i]);
          });
      }

    },


  },

 async  created() {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    this.audioCtx = new AudioContext();

    await this.loadClavSounds();
    await this.loadCelestaSounds();
    await this.loadSwellsSounds();
  }
}
</script>

<style>

.control {
  font-size: 40px;
  color: white;
}

</style>
